module.exports = __webpack_public_path__ + "static/logo-c968a47373ae69f8340384b66ef96d06.svg";